var exports = {
  "kL": "x31de4314--d66714--container",
  "Zq": "x31de4314--d66714--container-vertical",
  "DD": "x31de4314--d66714--title",
};

module.exports = exports;
